import React, { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb } from '@fikasio/react-ui-components';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import TemplateInformationsForm from 'components/templates/TemplateView/TemplateInformationsForm';
import BasePage from 'components/UI/BasePage';
import { useGetTemplatesQuery } from 'services/templates/api';
import links from 'utils/links';
import { spaLinkProps } from 'utils/spaLink';

const TemplateUpsertPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { templateId } = useParams<{ templateId: string; }>();
  const { data: templates } = useGetTemplatesQuery();

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname,
    });
  }, []);

  const template = templates && templates.find(temp => temp.id === templateId);

  return (
    <>
      <Helmet>
        <title>{t('createATemplate')}</title>
      </Helmet>
      <BasePage>
        <Breadcrumb
          items={[
            { ...spaLinkProps(links.paths.home, navigate), label: t('home') },
            { ...spaLinkProps(links.timesheet(), navigate), label: t('timesheet') },
            { label: t('createATemplate') },
          ]}
        />
        <h4>{t('createATemplate')}</h4>
        <TemplateInformationsForm
          template={template}
        />
      </BasePage>
    </>
  );
};

export default TemplateUpsertPage;
